
<div v-click-outside="() => isMobile() ? null :toggle(false)">
  <button class="button is-primary is-fullwidth is-small-tablet" @click="toggle()">
    View Quote
  </button>
  <div v-if="showSummary" class="quote-summary-dropdown">
    <quote-summary @hide="toggle(false)" />
  </div>
</div>
